/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Reviews_DescriptionInputs */

const he_hero_reviews_description = /** @type {(inputs: Hero_Reviews_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שתפו את החוויה שלכם עם מוצרים ועזרו לקונים אחרים לקבל החלטות טובות יותר.`)
};

const en_hero_reviews_description = /** @type {(inputs: Hero_Reviews_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share your experience with products and help other shoppers make better decisions.`)
};

/**
* | output |
* | --- |
* | "Share your experience with products and help other shoppers make better decisions." |
*
* @param {Hero_Reviews_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const hero_reviews_description = /** @type {((inputs?: Hero_Reviews_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Reviews_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_hero_reviews_description(inputs)
	return en_hero_reviews_description(inputs)
});